export default "__VITE_ASSET__bd3a81e2__"